<template>
    <section>
        <div
            class="box"
            v-if="allBrands.length > 0"
            :key="'brand__slider__box'"
        >
            <Flicking
                class="carousel"
                :options="{
                    align: 'prev',
                    circular: false,
                    duration: 200,
                    panelsPerView: panelsPerView,
                    easing: function(x) {
                        return x;
                    }
                }"
                @changed="flickingChanged"
                ref="flicking"
            >
                <div class="panel" v-for="brand in allBrands" :key="brand.id">
                    <div class="brand__container">
                        <div class="brand__box">
                            <router-link
                                class="img__box"
                                :to="{
                                    name: 'brands',
                                    params: {
                                        id: brand.id
                                    }
                                }"
                            >
                                <img
                                    :src="homeBrandImageUrl + brand.logo"
                                    :alt="brand.name"
                                />
                            </router-link>
                        </div>
                    </div>
                </div>
            </Flicking>

            <div class="nav__box">
                <div
                    class="prev"
                    v-if="isVisibleLeftButton"
                    :key="'left--button'"
                >
                    <button @click="prevSlide">
                        <svg
                            width="8"
                            height="13"
                            viewBox="0 0 8 13"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M6.73828 11.522L1.86872 6.65241L6.73828 1.78284"
                                stroke="white"
                                stroke-width="1.8"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                    </button>
                </div>

                <div
                    class="next"
                    v-if="isVisibleRightButton"
                    :key="'right--button'"
                >
                    <button @click="nextSlide">
                        <svg
                            width="8"
                            height="13"
                            viewBox="0 0 8 13"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M1.26172 11.522L6.13128 6.65241L1.26172 1.78284"
                                stroke="white"
                                stroke-width="1.8"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                    </button>
                </div>
            </div>
        </div>

        <div class="box" v-else>
            <h2>
                Ничего не найдено!
            </h2>
        </div>
    </section>
</template>

<script>
import { Flicking } from "@egjs/vue-flicking";
import { mapGetters, mapActions } from "vuex";

import MainSpinner from "../UI/MainSpinner.vue";

export default {
    components: {
        Flicking,
        MainSpinner
    },

    data() {
        return {
            lastProductIndex: 0,

            homeBrandImageUrl: "https://pos.buum.uz/uploads/brands/",

            isVisibleLeftButton: false,
            isVisibleRightButton: true,
            panelsPerView: 6
        };
    },

    computed: {
        ...mapGetters(["allBrands"])
    },

    watch: {
        allBrands() {
            this.changePanelsPerViewCount();
        }
    },

    methods: {
        async flickingChanged(...body) {
            if (this.lastProductIndex + 4 >= body[0].index) {
            }

            if (body[0].index === 0) this.isVisibleLeftButton = false;
            else this.isVisibleLeftButton = true;

            if (body[0].index + this.panelsPerView >= this.allBrands.length)
                this.isVisibleRightButton = false;
            else this.isVisibleRightButton = true;
        },

        async prevSlide() {
            await this.$refs.flicking.prev().catch(() => void 0);
            await this.$refs.flicking.prev().catch(() => void 0);
            await this.$refs.flicking.prev().catch(() => void 0);
        },

        async nextSlide() {
            await this.$refs.flicking.next().catch(() => void 0);
            await this.$refs.flicking.next().catch(() => void 0);
            await this.$refs.flicking.next().catch(() => void 0);
        },

        changePanelsPerViewCount() {
            const innerWidth = window.innerWidth;
            if (innerWidth >= 1200) this.panelsPerView = 6;
            if (innerWidth < 1200) this.panelsPerView = 5;
            if (innerWidth < 992) this.panelsPerView = 4;
            if (innerWidth < 768) this.panelsPerView = 3;
            if (innerWidth < 550) this.panelsPerView = 2.3;
            this.$refs.flicking.panelsPerView = this.panelsPerView;
        }
    },

    async mounted() {
        try {
            this.changePanelsPerViewCount();
        } catch {
            console.log("something went wrong!");
        }
    }
};
</script>

<style lang="scss" scoped>
@import url("../../../../../node_modules/@egjs/vue-flicking/dist/flicking.css");
// Or, if you have to support IE9
@import url("../../../../../node_modules/@egjs/vue-flicking/dist/flicking-inline.css");

.box {
    display: flex;
    position: relative;

    .slick-dots {
        position: relative;
    }

    .exp {
        img {
            height: 200px;
            width: 200px;
        }
    }

    .carousel {
        max-width: 1440px;
        overflow-x: hidden;

        .brand__container {
            position: relative;
            width: 100%;
            padding-top: 75%;

            .brand__box {
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                right: 0;
                padding: 5px 15px;

                .img__box {
                    display: block;
                    box-shadow: 0px 2px 8px 1px rgb(0 0 0 / 5%);
                    border-radius: 10px;
                    overflow: hidden;

                    width: 100%;
                    height: 100%;

                    &:hover {
                        cursor: pointer;
                        box-shadow: 0px 2px 8px 1px rgb(0 0 0 / 15%);
                    }

                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: fill;
                    }
                }
            }
        }
    }

    .nav__box {
        z-index: 20;
        .prev,
        .next {
            position: absolute;
            top: 38%;
        }

        .prev {
            left: 0;
            margin-left: 15px;
        }

        .next {
            right: 0;
            margin-right: 15px;
        }

        button {
            width: 40px;
            height: 40px;

            border: none;
            outline: none;
            font-size: 16px;
            border-radius: 4px;

            color: #ffffff;
            background-color: #3E5C45;

            &:hover {
                cursor: pointer;
                background-color: #6C9672;
            }
        }

        button.disabled {
            background-color: #e0e0e0;
            color: #808080;
        }
    }

    h2 {
        padding-right: 7px;
        padding-left: 7px;
        margin-bottom: 15px;
        font-family: Acrom, sans-serif;
        width: 100%;
        font-weight: 700;
        font-size: 22px;
        line-height: 1.4;
        color: #363f4d;
    }
}

@media only screen and (max-width: 550px) {
    .box {
        .nav__box {
            display: none;
        }
    }
}
</style>
